import { render, staticRenderFns } from "./TextAreaInput.vue?vue&type=template&id=5da29752&scoped=true"
import script from "./TextAreaInput.vue?vue&type=script&lang=js"
export * from "./TextAreaInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da29752",
  null
  
)

export default component.exports